<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.name"
          style="width: 200px"
          placeholder="姓名"
          clearable
          @clear="
            delete state.params.name;
            onLoad();
          "
        ></el-input>
        <el-cascader
          v-model="state.params.withholding_agent_id"
          :options="state.withholding_agent_data"
          :props="{ value: 'id', label: 'name' }"
          placeholder="扣缴义务人"
          filterable
          clearable
          @change="onWithholdingAgentChange"
          @clear="
            delete state.params.withholding_agent_type;
            delete state.params.withholding_agent_id;
          "
        />
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        class="payroll-record-table"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          prop="sn"
          align="center"
        />
        <el-table-column label="算税状态" width="120" align="center">
          <template #default="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.tax_failure_msg"
              v-if="row.tax_failure_msg"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
              >
                <c_status
                  arrName="payrollemployee_tax_status"
                  :value="row.tax_status"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
            <c_status
              arrName="payrollemployee_tax_status"
              :value="row.tax_status"
              style="margin: 0 auto"
              v-else
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column label="发放状态" width="120" align="center">
          <template #default="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.pay_failure_msg"
              v-if="row.pay_failure_msg"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
              >
                <c_status
                  arrName="payrollemployee_pay_status"
                  :value="row.pay_status"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
            <c_status
              arrName="payrollemployee_pay_status"
              :value="row.pay_status"
              style="margin: 0 auto"
              v-else
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :width="240"
          :formatter="$tab_TextFormat"
        >
          <template #default="{ row }">
            <div
              v-if="row.withholding_agent_name"
              :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
              :style="{
                '--dynamic-color':
                  row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
              }"
              class="withholding-badge"
            >
              {{ row.withholding_agent_name }}
            </div>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          :prop="item.field"
          :label="item.name"
          v-for="item in state.templateSortFields.filter(
            (w) => !['sn', 'remark'].includes(w.field)
          )"
          :key="item"
          :width="['idcard'].includes(item.field) ? 180 : 140"
          align="center"
        >
          <template #default="{ row, column }">
            <div
              v-if="row.isEdit && row.edit.includes(column.property)"
              @click.stop=""
            >
              <el-input-number
                v-model="row[column.property]"
                style="width: 100%"
                :precision="2"
                controls-position="right"
              ></el-input-number>
            </div>
            <template v-else>
              <div v-if="row[column.property]">
                {{ row[column.property] }}
              </div>
              <text v-else>-</text>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" :width="180" align="center">
          <template #default="{ row }">
            <el-input
              v-model="row.remark"
              v-if="row.isEdit"
              @click.stop=""
            ></el-input>
            <text v-else>
              {{ row.remark || "-" }}
            </text>
          </template>
        </el-table-column>
      </el-table>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref, h } from "vue";
import { salaryapply_record } from "@/http/salaryapply";
import { priceFormat } from "@/utils/qFormat";

export default {
  props: {
    id: Number,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      params: {},
      statistics: [],
      templateSortFields: [],
      selectFile: {},
      withholding_agent: {},
    });
    onMounted(() => {
      state.params.id = props.id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      salaryapply_record(state.params).then((res) => {
        if (res.status == 200) {
          const { list, statistics, templateSortFields } = res.data.data;
          state.tableData = list;
          state.statistics = statistics;
          state.templateSortFields = templateSortFields;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      }
      onLoad();
    };

    const getSummaries = () => {
      let res = [];
      res[0] = h("div", { style: { whiteSpace: "nowrap" } }, ["合计"]);
      const keys = Object.keys(state.statistics);
      keys.forEach((key) => {
        const index = state.templateSortFields.findIndex((w) => w.field == key);
        if (index > -1) res[index + 3] = priceFormat(state.statistics[key]);
      });
      return res;
    };

    return {
      state,
      tableDom,
      props,
      onLoad,
      onSortChange,
      getSummaries,
    };
  },
};
</script>
<style lang="less">
.payroll-dialog {
  .el-dialog__body {
    flex: 1;
    overflow: hidden;
  }
}
</style>
